import { Link } from 'react-router-dom';
import { Phone, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t, i18n } = useTranslation();
  
  const languages = [
    { code: 'en', label: 'English' },
    { code: 'pt', label: 'Português' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
    { code: 'es', label: 'Español' },
  ];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/logo.svg" 
                alt="Portugal Elite Estates" 
                className="w-12 h-12"
              />
              <div>
                <span className="font-heading text-xl font-semibold text-white">Portugal Elite</span>
                <span className="block text-[10px] tracking-[0.2em] uppercase text-white/50">Estates</span>
              </div>
            </div>
            <p className="text-white/60 leading-relaxed max-w-md">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6 text-white/80">{t('footer.navigate')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/60 hover:text-white transition-colors text-sm">{t('footer.home')}</Link>
              </li>
              <li>
                <Link to="/start-your-search" className="text-white/60 hover:text-white transition-colors text-sm">{t('footer.startSearch')}</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/60 hover:text-white transition-colors text-sm">{t('footer.contact')}</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6 text-white/80">{t('footer.contactTitle')}</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-primary flex-shrink-0" />
                <span className="text-white/60 text-sm">
                  {t('footer.availableOnRequest')}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            {t('footer.copyright', { year: currentYear })}
          </p>
          <div className="flex items-center gap-8">
            {/* Language Selector */}
            <div className="relative flex items-center gap-2" data-testid="language-selector">
              <Globe size={14} className="text-white/40" />
              <select
                value={i18n.language?.substring(0, 2) || 'en'}
                onChange={(e) => handleLanguageChange(e.target.value)}
                className="bg-transparent text-white/40 hover:text-white text-sm cursor-pointer focus:outline-none appearance-none pr-4"
                style={{ backgroundImage: 'none' }}
              >
                {languages.map((lang) => (
                  <option key={lang.code} value={lang.code} className="bg-[#0F172A] text-white">
                    {lang.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex gap-8 text-sm">
              <Link to="/privacy" className="text-white/40 hover:text-white transition-colors">{t('footer.privacy')}</Link>
              <Link to="/terms" className="text-white/40 hover:text-white transition-colors">{t('footer.terms')}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
